<template>
  <div>
    <div>
      <top-header></top-header>
    </div>
    <div class="content">
      <div class="content_banner">
        <div class="txt">
          <div class="txt_1">{{ $route.query.name }}</div>
          <div v-if="$route.query.name == '科研诚信'" class="text_2">
            科研项目科研诚信、、论文科研诚信、奖励科研诚信
          </div>
          <div v-if="$route.query.name == '医学创新'" class="text_2">
            科研管理（研究型医院、科研项目、科研平台、医学学科）、细胞治疗（体细胞、干细胞）
          </div>
          <div v-if="$route.query.name == '生物安全'" class="text_2">
            防控重大新发突发传染病、动植物疫情，加强生物技术研究开发与应用管理、加强病原微生物实验室生物安全管理，加强人类遗传资源与生物资源安全管理、防范外来物种入侵、保护生物多样性、应对微生物耐药、防范生物恐怖袭击与防御生物武器威胁、其他
          </div>
          <div v-if="$route.query.name == '科研伦理'" class="text_2">
            伦理委员会 伦理审查 伦理监管 受试者权益保护
          </div>
          <div v-if="$route.query.name == '医学教育'" class="text_2">
            毕业后教育、继续教育、基层能力提升
          </div>
          <div v-if="$route.query.name == '媒体动态'" class="text_2">
            通过互联网技术结合人工，每工作日对国内卫生健康行业重要媒体信息进行过滤并筛选出最重要、最热点、最有价值的媒体信息发布到平台
          </div>
          <div v-if="$route.query.name == '科学前沿'" class="text_2">
            从医学权威媒体、行业顶尖杂志等信息来源渠道筛选并摘译国内外医学科学前沿信息，为卫生部门领导及科研人员提供全球最新医学科研信息
          </div>
        </div>
        <div class="collect" v-if="isLogin">
          <span @click="handleTarck" v-if="!isTracked"
            ><i class="el-icon-star-off"></i> 资讯跟踪</span
          >
          <span @click="handleTarck" v-else
            ><i class="el-icon-star-on"></i> 取消跟踪</span
          >
        </div>
      </div>
      <div class="content_info">
        <div class="left">
          <ul
            class="infinite-list"
            v-infinite-scroll="load"
            :infinite-scroll-distance="100"
            style="overflow: auto; height: 500px;"
          >
            <li
              v-for="(item, index) in tableData"
              :key="index"
              @click="getDetail(item.id, item.infoUrl)"
            >
              <!-- <div class="info" v-html="item.divInfo"></div> -->
              <div class="title">
                <img v-if="item.isWechat == 1" src="../assets/wx.svg" alt="" />
                <img v-if="item.isWechat == 0" src="../assets/net.svg" alt="" />
                <div v-html="item.title"></div>
                <!-- {{ item.title.replace(/\/?.+?\/?>/g, "") }} -->
              </div>

              <div class="bot">
                <div>
                  <el-tag
                    class="tag"
                    size="mini"
                    v-for="(tag, tagIdx) in item.tagList"
                    :key="tagIdx"
                  >
                    {{ tag }}</el-tag
                  >
                </div>
                <div>
                  <span>{{ item.source ? item.source : "未知来源" }}</span>
                  <span class="date">{{ item.publishTime }}</span>
                </div>
              </div>
            </li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="!noMore">没有更多了</p>
          <!-- <el-pagination
            v-show="total > 0"
            class="pagination"
            background
            layout="total,prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page.sync="obj.pageNo"
          >
          </el-pagination> -->
        </div>
        <div class="right">
          <!-- <input type="text" placeholder="请输入" v-model="list.title "/> -->
          <div class="search_1">
            <el-input
              style="width: 70%"
              v-model="newObj.title"
              placeholder="请输入"
              size="normal"
              clearable
              @clear="handleClear"
            ></el-input>

            <button class="btn" @click="search">
              <img style="width: 12px" src="../assets/搜索1.png" alt="" />
              专题内搜索
            </button>
          </div>
          <div class="right_a" v-show="categoryList.length > 0">
            <div class="common">二级分类</div>
            <div class="item">
              <div
                class="item_e"
                :class="currentValue == item.name ? 'active' : ''"
                v-for="(item, index) in categoryList"
                :key="index"
                @click="change(item, index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- <div class="right_a" v-show="keywordsList.length > 0">
            <div class="common">关键词</div>
            <div class="item">
              <div
                @click="keywordPush(item)"
                class="item_e"
                :class="currentKeyWord == item.name ? 'active' : ''"
                v-for="(item, index) in keywordsList"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
          </div> -->
          <!-- <div class="right_a">
            <div class="common">属地</div>
            <div class="item">
              <div
                class="item_e"
                v-for="(item, index) in placeList"
                :key="index"
              >
                {{ item.value }}
              </div>
            </div>
          </div> -->
          <div class="right_a">
            <div class="common">时间范围</div>
            <div
              style="
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
              "
            >
              <el-date-picker
                v-model="value1"
                style="width: 64%"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="slectTime"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
              <!-- <el-button  style=" background-color: #0b70c1;color: #fff;" size="default" @click="timeBtn">确认</el-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <cenfooter></cenfooter>
    </div>
  </div>
</template>

<script>
import topHeader from "../components/home/headears.vue";
import cenfooter from "../components/home/footers.vue";
import {
  getArticlePage,
  getArticleTypeSubList,
  getArticleKeywordList,
  postFollowAddOrDel,
  getExist,
} from "@/api/api.js";
export default {
  components: {
    topHeader,
    cenfooter,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      list: {
        code: "",
        categoryId: "",
        endTime: "",
        keyWord: "",
        page: 1,
        publishTime: "",
        rows: 10,
        startTime: "",
        title: "",
      },
      newObj: {
        page: 1,
        keywords: "",
        title: "",
        typeThree: "",
        publicTime: "",
      },
      obj: {},
      tableData: [],
      keywordsList: [],
      categoryList: [],
      currentValue: "全部",
      currentKeyWord: "全部",
      total: null,
      loading: false,
      noMore: false,
      isTracked: false,
    };
  },
  mounted() {
    this.init(true);
    this.getCategory();
    // this.getkeyword({
    //   type: this.$route.query.type,
    // });
    window.document.title = "医学科教信息平台-" + this.$route.query.name;
    if (isLogin) {
      getExist({ typeSolrkey: this.$route.query.id }).then((res) => {
        this.isTracked = res.data;
      });
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id;
    },
    isLogin() {
      return sessionStorage.getItem("isLogin") === "1";
    },
  },
  methods: {
    // 选择时间
    slectTime(e) {
      if (!this.value1) {
        this.value1 = "";
        this.newObj.publicTime = "";
      } else {
        var Time = `${e[0]}_${e[1]}`;
        this.newObj.publicTime = Time;
      }
      this.init(true);
    },
    // 搜索
    search() {
      this.init(true);
    },
    // 跟踪
    handleTarck() {
      postFollowAddOrDel({ typeSolrkey: this.$route.query.id }).then((res) => {
        if (res.data.code === 200) {
          this.isTracked = !this.isTracked;
        }
      });
    },
    // 点击关键词
    async keywordPush(e) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.currentKeyWord = e.name;

      if (e.name == "全部") {
        this.newObj.keywords = "";
      } else {
        this.newObj.keywords = e.name;
      }

      this.newObj.page = 1;
      await this.init(true);
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    getDetail(e, infoUrl) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id: e, type: this.$route.query.id },
      });
      window.open(this.isLogin ? routerUrl.href : infoUrl);
    },
    async init(isClear) {
      if (isClear) {
        this.newObj.page = 1;
        this.tableData = [];
      }
      //获取文章列表
      this.obj = {
        condition: {
          keywords: this.newObj.keywords,
          publicTime: this.newObj.publicTime,
          sort: "",
          sourceDate: "",
          typeThree: this.newObj.typeThree,
          title: this.newObj.title,
          type: this.$route.query.id,
        },
        offset: "",
        order: "",
        pageNo: this.newObj.page,
        pageSize: 10,
        sidx: "",
      };

      const res = await getArticlePage(this.obj);
      if (res.data.list.length === 0) {
        this.noMore = false;
      } else {
        this.noMore = true;
      }
      this.loading = false;
      this.total = res.data.total;
      this.tableData = this.tableData.concat(res.data.list);
      this.tableData.map((item) => {
        let list = [];
        if (item.typeTwo) {
          let tagList = item.typeTwo.split(",");
          tagList.map((tag) => {
            if (tag.trim() === "科研诚信") {
              list.push("诚信");
            } else if (tag.trim() === "科研伦理") {
              list.push("伦理");
            } else {
              list.push(tag);
            }
          });
          item.tagList = list;
        }
        if (item.typeThree) {
          let tagList = item.typeThree.split(",");
          tagList.map((tag) => {
            list.push(tag);
          });
          item.tagList = list;
        }
      });
    },
    //获取二级分类
    async getCategory() {
      var obj = {
        type: this.$route.query.type,
      };
      const res = await getArticleTypeSubList(obj);

      this.categoryList = res.data.data.rows;
      if (this.categoryList.length > 0) {
        this.categoryList.unshift({ name: "全部" });
      }
    },
    //获取关键词
    // async getkeyword(obj) {
    //   const res = await getArticleKeywordList(obj);
    //   this.keywordsList = res.data.data.rows;
    //   if (this.keywordsList.length > 0) {
    //     this.keywordsList.unshift({ name: "全部" });
    //   }
    // },
    // 点击二级分类
    async change(item, index) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.currentValue = item.name;
      this.currentKeyWord = "全部";
      this.newObj.keywords = "";
      var obj = {
        typeThree: "",
        type: this.$route.query.type,
      };
      obj.typeThree = item.id;
      // this.getkeyword(obj);

      if (item.name == "全部") {
        this.newObj.typeThree = "";
      } else {
        this.newObj.typeThree = item.name;
      }
      this.newObj.page = 1;
      await this.init(true);
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    //分页
    handleCurrentChange(val) {
      this.newObj.page = val;
      this.init();
    },
    //取消搜索框
    handleClear() {
      this.newObj.title = "";
      this.init(true);
    },
    timeClear() {
      // this.newObj.publicTime = "";
      this.init();
    },
    // 无限滚动加载
    load() {
      this.loading = true;
      setTimeout(() => {
        this.newObj.page++;
        this.init();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  // margin-top: 32px;
  float: right;
}
.active {
  background-color: #0b70c1 !important;
  color: #fff;
}
.content {
  width: 90%;
  background-color: #fff;
  margin: 20px auto;
  padding: 20px;
  .content_banner {
    height: 160px;
    background: url(../assets/banner.png) no-repeat 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .collect {
      position: absolute;
      right: 20px;
      bottom: 15px;
      font-size: 17px;
      color: #fff;
      cursor: pointer;
    }
    .txt {
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      text-align: center;
      .txt_1 {
        font-size: 28px;
        text-align: center;
        margin-bottom: 10px;
      }
      .text_2 {
        width: 70%;
        margin: 0 auto;
      }
    }
  }
  .content_info {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 70%;
      height: 800px;
      li {
        border-bottom: 1px solid #f0f0f0;
        padding: 10px 0;
      }
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22px;
        margin-bottom: 10px;
        display: flex;
        cursor: pointer;
        img {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 3px;
          margin-right: 4px;
        }
      }
      .info {
        color: rgba(0, 0, 0, 0.4);
        font-size: 13px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        white-space: normal;
        margin-bottom: 10px;
      }
      .bot {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.6);
        line-height: 18px;
        .tag {
          margin-right: 4px;
        }
        .date {
          margin-left: 10px;
        }
      }
    }
    .right {
      width: 28%;
      .search_1 {
        display: flex;
      }
      ::v-deep .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
      .btn {
        width: 30%;
        transition: 0.3s;
        border: 0;
        text-align: center;
        height: 40px;
        background-color: #0b70c1;
        font-size: 13px;
        color: #fff;
        cursor: pointer;
        border-radius: 0 5px 5px 0;
      }

      .right_a {
        margin-top: 30px;
        .common {
          width: 100px;
          color: rgba(11, 112, 193, 1);
          font-size: 16px;
          // text-align: center;
          padding-left: 10px;
          font-weight: 800;
          border-left: 4px solid rgba(11, 112, 193, 1);
        }
        .item {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item_e {
            padding: 8px;
            cursor: pointer;
            background-color: #f5f5f5;
            margin-right: 15px;
            margin-top: 15px;
          }
        }
      }
    }
  }
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.1);
}
</style>
